import axios from 'axios';
import { searchToObject } from '../helpers';

export function createTicket(values, basket) {
  /*
  * отправка запроса на создание билета
  */
  return new Promise((resolve, reject) => {

    const query = searchToObject();

    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_LINK}/ticket/create-reserv`,
      data: {
        phone: values.phone,
        note: values.fullName,
        email: values.email,
        events: basket,
        isReserv: false
      },
      params: query
    })
    .then(res => res.data)
    .then(data => {
      resolve(data);
    })
    .catch(err => {
      if (err.response.data) {
        if (err.response.data.msg) {
          return reject((err.response.data.msg).toString());
        }
      }
      reject(err);
    })

  });

}


// WEBPACK FOOTER //
// ./src/services/api/ticket.js